export const DEFAULT_SWAP_SLIPPAGE_TOLERANCE_PCT = 0.1;

/**
 * Account budget for a swap route, applied to both Jupiter and Titan (which
 * maps it to `accountsLimitTotal`). Re-exported from the SDK, which falls back
 * to the same value when a caller passes none — a second copy here would let a
 * quote and the route built from it disagree on the budget.
 */
export { DEFAULT_SWAP_MAX_ACCOUNTS } from '@velocity-exchange/sdk';

/**
 * Retry ladder for the account budget. Neither provider can route most pairs
 * below ~20 accounts, so stepping under this floor only wastes an attempt.
 */
export const SWAP_MAX_ACCOUNTS_RETRY_STEP = 8;
export const MIN_SWAP_MAX_ACCOUNTS = 20;
